module.exports = __webpack_public_path__ + "static/l3-harris-add57cea09e643dac1930ce8a89c8fbd.png";